<template>
	<div class="page-mdl">
		
		<div class="colleges-head">
			<img class="bg" src="../../static/img/college-head.png" alt="">
			<div class="box-wrap" v-if="detail">
				<div class="box">
					<img class="logo" :src="detail.orgLogo || dfImg" alt="">
					<div class="info">
						<h3>{{detail.orgName}}</h3>
						<p>{{detail.courseCounts || 0}}门课程  |  {{detail.teacherCounts || 0}}名教师</p>
					</div>
				</div>
				<div class="des" v-if="detail.introduction">{{detail.introduction}}</div>
			</div>
		</div>
		
		<div class="m-tag-box2">
			<span :class="{act:index==tagIndex}" v-for="(item,index) in tagList" :key="index"
				@click="changeTag(index)">{{item}}</span>
		</div>
		
		<div class="tag-content">
			<div v-show="tagIndex==0">
				<van-list
					v-if="courseInfo.list.length>0"
					v-model="courseInfo.loading"
					:finished="courseInfo.finished"
					finished-text="没有更多了"
					:offset="30"
					@load="getOpenCourse"
				>
					<ul class="course-list" >
						<li v-for="(item,index) in courseInfo.list" :key="item.courseId" @click="goCourseDetail(item)" >
							<div class="img-box">
								<img :src="item.courseImg || dfImg" alt="">
								<div v-if="item.courseLevelName" class="label">{{item.courseLevelName}}</div>
								<div class="visit">{{item.allChooseCount || 0}}人观看</div>
							</div>
							<div class="info">
								<h4 class="title">{{item.courseName}}</h4>
								<p>{{item.orgName}} | {{item.teacherName}}</p>
								<div class="btm">
									<span class="status" :class="item.offerCoursesClass">{{item.offerCoursesName}}</span>
									<div class="date">{{item.termName}}</div>
								</div>
							</div>
						</li>
					</ul>
				</van-list>
				<van-empty v-if="courseInfo.finished && !courseInfo.list.length>0"  description="暂无开放课程" />
			</div>


			<!-- 教师团队 -->
			<div v-show="tagIndex==1">
				<van-list
					v-if="teacherInfo.list.length>0"
					v-model="teacherInfo.loading"
					:finished="teacherInfo.finished"
					finished-text="没有更多了"
					:offset="30"
					@load="getTeacher"
				>
					<ul class="teacher-list">
						<li v-for="(item,index) in teacherInfo.list" :key="item.teacherId">
							<img class="pic" :src="item.headImage || dfHead2" alt="">
							<div class="info">
								<h3 class="name">{{item.teacherName}}</h3>
								<div class="label">{{item.orgName}}  {{item.title?' | '+item.title:''}}</div>
								<div class="des" :class="{up:item.showDesAll}">
									{{(item.showDesAll || !item.introduction2)?item.introduction:item.introduction2}}
									<span v-if="item.introduction2" @click="showMoreDes(index)">{{(item.showDesAll)?'收起':'展开'}}</span>
								</div>
								<!-- <div class="des">{{item.introduction}}</div> -->
								<a class="more" href="javascript:;">主持建设课程{{item.lecturerCounts || 0}}门  |  参与建设课程{{item.buildCounts || 0}}门</a>
							</div>
						</li>
					</ul>
				</van-list>
				<van-empty v-if="teacherInfo.finished && !teacherInfo.list.length>0"  description="暂无教师" />
			</div>
			
			
		</div>
		
		
	</div>
</template>

<script>
import { getList } from '@/static/js/list-vant.js'
export default {
	data () {
		return {
			tagList:[ '开放课程','教师团队' ],
			tagIndex:0,
			
			detail:null,	//院校详情
			orgId:'',		//院校id
			courseInfo:{	//开放课程
				list:[],
				pageNum:1,
				pageSize:10,
				total:0,
				loading: true,
				finished: false,
			},
			teacherInfo:{	//教师团队
				list:[],
				pageNum:1,
				pageSize:5,
				total:0,
				loading: true,
				finished: false,
			}
		}
	},
	
	async created(){
		await this.$onLaunched;		//监听加载了APP.vue中的onLaunched的异步后执行
		this.schoolsId = this.$route.params.id
		this.getDetail()
		this.getOpenCourse(true)
		this.getTeacher(true)
	},
  
	computed:{
		
	},
  
	methods:{
		changeTag(index){
			this.tagIndex = index 
		},
		
		//获取院校详情
		getDetail(){
			const { schoolsId } =this
			this.$axios({
				url:`/jxedu/api/site/findPartnersOrgDetail/${schoolsId}`,
			}).then(res=>{
				let detail = res.data
				this.detail = detail
			})
		},
		
		//获取院校开放课程列表
		getOpenCourse(isReach){
			const { schoolsId } =this
			getList({
				url:`/jxedu/api/site/findOpenCourse`,
				page:this,				//必传,当前页面的this
				isReach,
				listName:'courseInfo',
				data:{
					schoolsId,
				},
				cbListFn:(res)=>{
					return res.rows	//这里接口返回的数据层级，看列表属于哪一级
				},
				handleFn:(item)=>{
					switch(item.courseLevel){	//课程级别：0普通网课 1联盟精品课 2国家精品课 3省级精品课
						case 0: item.courseLevelName = ''; item.courseLevelClass = ''; break;
						case 1: item.courseLevelName = '省级精品'; item.courseLevelClass = 'blue'; break;
						case 2: item.courseLevelName = '国家精品'; item.courseLevelClass = 'orange'; break;
						case 3: item.courseLevelName = '省级线上一流'; item.courseLevelClass = 'green'; break;
						case 4: item.courseLevelName = '国家线上一流'; item.courseLevelClass = 'red'; break;
					}
					switch(item.offerCoursesStu){	//开课状态：0:全部，1:即将开课,2:开课中,3:已结课,4:暂未开课
						case 1: item.offerCoursesName = '即将开课'; item.offerCoursesClass = 'orange'; break;
						case 2: item.offerCoursesName = '开课中'; item.offerCoursesClass = 'blue'; break;
						case 3: item.offerCoursesName = '已结课'; item.offerCoursesClass = 'gray'; break;
						case 4: item.offerCoursesName = '暂未开课'; item.offerCoursesClass = 'gray'; break;
					}
					return item
				}
			})
			
		},
		
		//获取教师团队
		getTeacher(isReach){
			const { schoolsId } =this
			getList({
				url:`/jxedu/api/site/findTeacherTeam`,
				page:this,				//必传,当前页面的this
				isReach,
				listName:'teacherInfo',
				data:{
					schoolsId,
				},
				cbListFn:(res)=>{
					return res.rows	//这里接口返回的数据层级，看列表属于哪一级
				},
				handleFn:(item)=>{
					if(item.introduction && item.introduction.length>50){
						item.showDesAll = false
						item.introduction2 = item.introduction.slice(0,48)+'...'
					}
					return item
				}
			})
		},

		//跳转教师详情页
		// goTeacherDetail(item){
		// 	this.goUrl({name:'teacherDetail',params:{ id:item.teacherId }, query:{ schoolsId : this.schoolsId}})
		// },
		
		//教师团队描述展开收起
		showMoreDes(index){
			const { showDesAll } = this.teacherInfo.list[index]
			this.teacherInfo.list[index].showDesAll = !showDesAll
		}
	}
}
</script>

<style lang="less" scoped>
@vm: 7.5vw;
@import '~@/static/css/m-course.less';
@import '~@/static/css/m-teacher.less';
.colleges-head{
	.bg{ width:100%; height:300/@vm; }
	.box-wrap{
		background:#fff; border-radius:24/@vm  24/@vm  0  0; padding:0 32/@vm 40/@vm; margin-top:-60/@vm; position:relative; z-index:9;
		.box{
			display:flex; 
			.logo{ width:180/@vm; height:190/@vm; border-radius:100%; margin-right:24/@vm; position:relative; top:-40/@vm; }
			.info{
				padding-top:30/@vm; flex:1;
				h3{ font-size:34/@vm; line-height: 34/@vm; font-weight: bold; color:#333333; margin-bottom:20/@vm;}
				p{ font-size:24/@vm; color:#666666; line-height:24/@vm;}
			}
		}
		.des{
			background:#F7F8FA; color:#666666; padding:24/@vm 20/@vm; border-radius:6/@vm; line-height:36/@vm;
		}
	}
}
.m-tag-box2{
	justify-content: flex-start;
	span{ margin-right:68/@vm; }
}
.tag-content{
	padding:36/@vm 32/@vm;
}
</style>



// WEBPACK FOOTER //
// src/pages/colleges-detail/tpl-mobile.vue